import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'insertHtmlLink',
	standalone: true
})
export class InsertHtmlLinkPipe implements PipeTransform {
	public transform(linkText: string, url: string, id = '', cssClass = 'prism-link'): string {
		return `<a href="${url}" id="${id}" class="${cssClass}">${linkText}</a>`;
	}
}
